import { defineMessages } from 'react-intl'

export const ancillaryTypeMessages = defineMessages({
  insurance: {
    id: 'ancillaries.form.insurance.label',
    defaultMessage: 'Insurance'
  },
  serviceFee: {
    id: 'ancillaries.form.serviceFee.label',
    defaultMessage: 'Service Fee'
  },
  luggage: {
    id: 'ancillaries.form.luggage.label',
    defaultMessage: 'Luggage'
  },
  carryOn: {
    id: 'ancillaries.form.carryOn.label',
    defaultMessage: 'Carry On'
  }
})
